import React from "react";
import DefaultLoader from "./DefaultLoader";

/**
 * Custom loading overlay component for AG Grid
 * Displays a loader with a configurable message
 */
const CustomLoadingOverlay = (props) => {
  const { loadingMessage = "Loading data..." } = props;

  return <DefaultLoader message={loadingMessage} displayModal={true} />;
};

export default CustomLoadingOverlay;
